export const mockProducts = [
  {
    id: 'prod_001',
    title: 'Bague Éclat Or Jaune',
    sku: 'BG-OR-001',
    price: 1250,
    compareAtPrice: 1490,
    currency: 'EUR',
    image: 'https://placehold.co/80x80/f5f0e8/c4a882?text=Bague',
    stockStatus: 'available',
    variants: [
      { id: 'var_001', label: 'Or jaune / Taille 52', stock: 2 },
      { id: 'var_002', label: 'Or jaune / Taille 54', stock: 0 },
      { id: 'var_003', label: 'Or rose / Taille 52', stock: 1 },
    ],
  },
  {
    id: 'prod_002',
    title: 'Collier Fil Diamant',
    sku: 'CO-DIA-002',
    price: 2800,
    compareAtPrice: 3200,
    currency: 'EUR',
    image: 'https://placehold.co/80x80/f0f0f5/9090c0?text=Collier',
    stockStatus: 'low_stock',
    variants: [
      { id: 'var_004', label: '42 cm', stock: 1 },
      { id: 'var_005', label: '45 cm', stock: 0 },
    ],
  },
  {
    id: 'prod_003',
    title: 'Bracelet Jonc Argent',
    sku: 'BR-ARG-003',
    price: 380,
    currency: 'EUR',
    image: 'https://placehold.co/80x80/f0f5f0/80c080?text=Bracelet',
    stockStatus: 'unavailable',
    variants: [{ id: 'var_006', label: 'Taille unique', stock: 0 }],
  },
  {
    id: 'prod_004',
    title: "Boucles d'oreilles Perle",
    sku: 'BO-PER-004',
    price: 680,
    compareAtPrice: 780,
    currency: 'EUR',
    image: 'https://placehold.co/80x80/f5f5f0/c0c080?text=Boucles',
    stockStatus: 'available',
    variants: [
      { id: 'var_007', label: 'Perle blanche', stock: 3 },
      { id: 'var_008', label: 'Perle crème', stock: 2 },
    ],
  },
  {
    id: 'prod_005',
    title: 'Pendentif Solitaire',
    sku: 'PE-SOL-005',
    price: 1900,
    currency: 'EUR',
    image: 'https://placehold.co/80x80/f5f0f5/c080c0?text=Pendentif',
    stockStatus: 'available',
    variants: [
      { id: 'var_009', label: 'Or blanc / 0.3 ct', stock: 1 },
      { id: 'var_010', label: 'Or jaune / 0.3 ct', stock: 2 },
    ],
  },
];
